// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-components-showTodos-todoList-todoList-module__todoList,\n.src-components-showTodos-todoList-todoList-module__todoListCompleted {\n  margin-bottom: 10px;\n}\n", "",{"version":3,"sources":["webpack://./src/components/showTodos/todoList/todoList.module.css"],"names":[],"mappings":"AAAA;;EAEE,mBAAmB;AACrB","sourcesContent":[".todoList,\n.todoListCompleted {\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"todoList": "src-components-showTodos-todoList-todoList-module__todoList",
	"todoListCompleted": "src-components-showTodos-todoList-todoList-module__todoListCompleted"
};
export default ___CSS_LOADER_EXPORT___;
